import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class AttachmentService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    getKeyArt(entityID: string) {
        return this.toRLService<Models.IKeyArtResponse>("/api/attachment/getkeyart").get({ entityID: entityID }).$promise;
    }
    saveKeyArt(request: Models.IEntityAttachmentRequest) {
        return this.toRLService<void>("/api/attachment/savekeyart/").post(request).$promise;
    }

    saveAttachment(request: Models.IEntityAttachmentRequest) {
        return this.toRLService<void>("/api/attachment/saveentityattachment/").post(request).$promise;
    }

    saveRLAttachment(request: Models.IAttachmentRequest) {
        return this.toRLService<void>("/api/attachment/SaveAttachment/").post(request).$promise;
    }

    getAssetAttachments(entityID: string, attachmentTypeID: number) {
        var data = {
            id: entityID,
            attachmentTypeId: attachmentTypeID
        };
        return this.toRLService<Models.IAssetAttachment>("/api/attachment/getassetattachments/").query(data).$promise;
    }

    rotateImage(charTypeID: number, recID: number, attachmentID: number, attachmentTypeID: number, clockwiseStepsTimes90: number) {
        var data = {
            charTypeID: charTypeID,
            recID: recID,
            attachmentID: attachmentID,
            attachmentTypeID: attachmentTypeID,
            clockwiseStepsTimes90: clockwiseStepsTimes90
        };
        return this.toRLService<void>("/api/attachment/rotateimage/").post(data).$promise;
    }

    deleteAssetAttachment(charTypeID: number, recID: number, attachmentID: number, attachmentTypeID: number): ng.IPromise<any> {
        var data = {
            charTypeID: charTypeID,
            recID: recID,
            attachmentID: attachmentID,
            attachmentTypeID: attachmentTypeID
        };
        return this.toRLService<void>("/api/attachment/deleteassetattachment").post(data).$promise;
    }

}